export const RETOUCH_UPLOAD_EXTENSIONS = new Set([
    "jpg",
]);

export const RETOUCH_UPLOAD_ACCEPT = ".jpg,image/jpeg";
export const RETOUCH_SINGLE_UPLOAD_ACCEPT = RETOUCH_UPLOAD_ACCEPT;

export function retouchFileExtension(fileOrName) {
    const name = typeof fileOrName === "string" ? fileOrName : fileOrName?.name;
    return String(name || "").split(".").pop()?.toLowerCase() || "";
}

export function isSupportedRetouchFile(file) {
    return RETOUCH_UPLOAD_EXTENSIONS.has(retouchFileExtension(file));
}

export function isJpgRetouchFile(file) {
    return retouchFileExtension(file) === "jpg";
}

export function fileNameFromPath(relativePath) {
    return String(relativePath || "").split("/").pop() || "";
}

export function retouchRelativePath(file, forcedRelativePath = "") {
    const raw = file?.webkitRelativePath || file?.name || "";
    const parts = String(raw).split("/").filter(Boolean);
    const versionIndex = parts.findIndex((part) => part === "original" || /^v[1-9]\d*$/.test(part));
    return forcedRelativePath || (versionIndex === -1 ? parts.join("/") : parts.slice(versionIndex + 1).join("/"));
}

export function parseRetouchUploadFiles(fileList, { forcedRelativePath = "" } = {}) {
    const files = [];
    const unsupported = [];
    for (const file of Array.from(fileList || [])) {
        if (!isSupportedRetouchFile(file)) {
            unsupported.push(file);
            continue;
        }
        const relativePath = retouchRelativePath(file, forcedRelativePath);
        if (!relativePath) continue;
        files.push({ file, version: "latest", resolvedVersion: "", relativePath, size: file.size, status: "pending", progress: 0 });
    }
    return { files, unsupported };
}

export function findRetouchFilenameMismatches(files, photos) {
    const expectedPaths = new Set((photos || []).map((photo) => photo.relativePath).filter(Boolean));
    return (files || []).filter((file) => !expectedPaths.has(file.relativePath));
}

export function alignRetouchUploadPaths(files, photos) {
    const expectedPaths = (photos || []).map((photo) => photo.relativePath).filter(Boolean);
    const expectedSet = new Set(expectedPaths);
    const byName = new Map();
    for (const path of expectedPaths) {
        const name = fileNameFromPath(path);
        byName.set(name, [...(byName.get(name) || []), path]);
    }
    return (files || []).map((file) => {
        if (expectedSet.has(file.relativePath)) return file;
        const matches = byName.get(fileNameFromPath(file.relativePath)) || [];
        return matches.length === 1 ? { ...file, relativePath: matches[0] } : file;
    });
}
